import {theme as defaultTheme} from '@miro-site/design-tokens'

const colors = {
  secondary4: '#F5F5F7',
  secondary8: '#EBEBEF',
  secondary20: '#CDCCD7',
  secondary40: '#9B99AF',
  secondary60: '#5F5C80',
  gray: '#686786',
}

const templates = {
  buttons: {
    transparent: {
      color: defaultTheme.colors.primaryIndigo,
      border: `1px solid ${colors.secondary20}`,
      background: 'transparent',
      ':hover': {
        borderColor: 'transparent',
        color: defaultTheme.colors.primaryWhite,
        background: defaultTheme.colors.primaryBlueHover,
      },
      ':focus': {
        ...defaultTheme.focus.outlines.default,
      },
    },
  },
  colors,
  elevation: {
    overlay: '2px 4px 16px rgba(0, 0, 0, 0.1)',
    topBar: '0px 4px 12px rgba(5, 0, 56, 0.07)',
    fixedSearch: '0px 4px 12px rgba(5, 0, 56, 0.12)',
  },
}
const miroverseHighlighted = {
  container: {
    verticalPadding: 20,
    horizontalPadding: 20,
    radius: 10,
    background: colors.secondary4,
  },
  title: {
    as: 'h4',
    variant: 'p2',
    fontWeightV1: 500,
    fontWeightV2: 400,
    colorV1: 'primaryIndigo',
    colorV2: 'placeholderColor',
    margins: {
      afterTitle: [null, 12],
    },
  },
  itemContainer: {
    verticalPadding: 15,
    link: {
      dividerColor: 'lightGray',
    },
    itemTitle: {
      fontSize: 14,
      lineHeight: 18,
      color: 'primaryIndigo',
    },
    itemDescription: {
      fontSize: 12,
      lineHeight: 20,
      color: colors.gray,
    },
    imageWidthV1: '100%',
    imageWidthV2: '25%',
    textWidthV2: '75%',
    margins: {
      afterImage: '5%',
    },
  },
  actionLink: {
    variant: 'regular',
    color: 'default',
    size: 'default',
    withArrow: true,
    fontSize: 14,
    fontWeight: 400,
    margins: {
      beforeLink: 15,
    },
  },
}

const theme = {
  ...defaultTheme,
  templates,
  miroverseHighlighted,
}

export type TemplatesTheme = typeof theme

export default theme
